import { baseApi } from "./index";

export const newsRoomApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getNewsRoom: builder.query({
            query: ({ page = 1, locale }) => ({
                url: "/news",
                method: "GET",
                params: {
                    page,
                    locale,
                },
            }),
            providesTags: ["NewsRoom"],
        }),
    }),
});

export const {
    useGetNewsRoomQuery,
} = newsRoomApi;
